import type { NuxtApp } from '#app';
import type { IPageResponse, IResponse, RequestConfig } from '../interface/common';
import type {
  Character,
  CharacterRequest,
  CharacterListRequest,
  CharacterXiheRequest,
} from '../interface/character';
import { fetch } from '../request';

export const getCharacter = (params: CharacterRequest) =>
  fetch<IResponse<Character>>('/material/youyan_config/character_detail/', {
    params,
  });

export const getCharacterFromXihe = (params: CharacterXiheRequest) =>
  fetch('/hetu/xhuman/v2/slice/detail_for_youyan_landing_page', { params });

export const getCharacterList = (
  params: CharacterListRequest,
  config?: RequestConfig,
  nuxtApp?: NuxtApp,
) =>
  fetch<IPageResponse<Character>>(
    '/material/youyan_config/character_collection_page/',
    {
      params,
      ...config,
    },
    nuxtApp,
  );

export const getHomeCharacterList = () =>
  fetch<IPageResponse<Character>>('/material/youyan_config/character_show_of_index/');
